import actionTypes from '../../actions/actionTypes'
import { Map, fromJS, List } from 'immutable'
import { returnStateIfNoAction } from '../helpers'
import { PROGRAM_DEFAULT } from '../../constants/state'
import { deleteItem, updateOrder, updateFractalOrder } from './helpers'


const INIT_STATE = fromJS(PROGRAM_DEFAULT.itemSelectionsDisplay)

const _itemFactory = (pk, type, selectionPk, cinemas, order = [], draft = false) => {
    return Map({
        pk: pk,
        type: type,
        selectionPk: selectionPk,
        cinemas: cinemas,
        order: List(order),
        draft: draft
    })
}


const addOrUpdateItem = (state, action) => state.setIn(
    ['items', action.payload.pk.toString()], 
    _itemFactory(
        action.payload.pk,
        action.payload.type, 
        action.payload.selectionPk, 
        action.payload.cinemas,
        action.payload.order,
        action.payload.draft
    )
)


const itemSelectionsDisplayReducer = (state = INIT_STATE, action) => {

    returnStateIfNoAction(action, state)

    switch(action.type){
        case actionTypes.ITEMSELECTIONSDISPLAY_UPDATE_ITEM:
            return addOrUpdateItem(state, action)
        case actionTypes.ITEMSELECTIONSDISPLAY_DELETE_ITEM:
            return deleteItem(state, action)
        case actionTypes.ITEMSELECTIONSDISPLAY_UPDATE_ORDER:
            return updateOrder(state, action)
        case actionTypes.ITEMSELECTIONSDISPLAY_UPDATE_ITEM_ORDER:
            return updateFractalOrder(state, action)
        default:
            return state;
    }
}

export default itemSelectionsDisplayReducer;


